/** The Stripe round-trip for the deck shop: which app path the buyer leaves
 *  from (sent as `returnPath` with the checkout), and reading the
 *  ?deck_paid=1&deck=<keys> return Stripe's success_url lands on. */

/** App-relative path of the current page — the router basename (PUBLIC_URL on
 *  GitHub Pages) is stripped because the backend appends this to
 *  FRONTEND_BASE_URL, which already carries it. Works without router context,
 *  which the checkout modal lacks inside drei's <Scroll html>. */
export function currentReturnPath(
  pathname: string = window.location.pathname,
): string {
  const base = process.env.PUBLIC_URL || "";
  const path =
    base && pathname.startsWith(base) ? pathname.slice(base.length) : pathname;
  return path || "/";
}

/** Deck keys from a post-payment return (?deck_paid=1&deck=guidance,mediumship),
 *  or null when this isn't one. */
export function parseDeckReturn(search: string): string[] | null {
  const params = new URLSearchParams(search);
  if (params.get("deck_paid") !== "1") return null;
  const keys = (params.get("deck") ?? "")
    .split(",")
    .map((k) => k.trim())
    .filter(Boolean);
  return keys.length ? keys : null;
}

/** `href` without the return params — what replaceState puts in the address bar
 *  so a reload (or a shared link) doesn't re-open the confirmation. */
export function stripDeckReturnParams(href: string): string {
  const url = new URL(href);
  for (const key of ["deck_paid", "deck"]) url.searchParams.delete(key);
  return url.pathname + url.search + url.hash;
}
